const TopSpace = ({children}) => {
    return (
        <div className="top-space">
            {children}
        </div>
    );
};

export default TopSpace;